export default {
  allMsg: 'All messages',
  systemMsg: 'System messages',
  personMsg: 'Manual messages',
  unread: 'Unread',
  seeDetail: 'See Details',
  read: 'Read',
  replyNow: 'reply now',
  message: 'Message',
  operateSuccess: 'Operate successfully',
  holder: {
    searchHolder: 'Package No./Order No./Item No.',
  },
  addAcBuy: 'Join AcBuy Discord & Win ¥2000 CASH!',
  flatActivity: '🎄 Christmas Must-Have Deals',
  joinNow1: 'Shop Now',
  tips1: '🎁Enjoy Up to 80% OFF',
  tips2: '🎅Limited-Time Holiday Deals!',
}
